'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { useState } from 'react';
import { PageNavigation } from '@/components/client';
import { DonationReviewList } from './_components/DonationReviewList';
import { LocalMarketReviewList } from './_components/LocalMarketReviewList';
import { type ReviewFilter, ReviewFilterChips } from './_components/ReviewFilterChips';
const ReviewsPage = () => {
  const $ = _c(4);
  const [filter, setFilter] = useState("donation");
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <PageNavigation hideHomeButton={true} />;
    t1 = <h1 className={cn("px-20 pb-20 font-700 text-Gray-900 typo-h5", "mobile-tablet:sr-only")}>내가 남긴 후기</h1>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== filter) {
    t2 = <>{t0}{t1}<ReviewFilterChips value={filter} onChange={setFilter} />{filter === "donation" ? <DonationReviewList /> : <LocalMarketReviewList />}</>;
    $[2] = filter;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default ReviewsPage;